"use client";

import { Flex } from "@chakra-ui/react";
import { EmptyState } from "@/components/feedback";
import { Button, Text } from "@/components/ui";
import { useTenantContentSettingsGet } from "@/features/profile-settings/hooks/useTenantContentSettingsGet";
import { useTenantData } from "@/hooks";

interface MicrositeListFetchErrorProps {
  onRetry: () => void;
  isRetrying?: boolean;
  testId?: string;
  title?: string;
  message?: string;
}

/** CMS-backed retry UI for public listing pages (classes, teachers, locations). */
export function MicrositeListFetchError({
  onRetry,
  isRetrying = false,
  testId = "microsite-list-retry-button",
  title,
  message,
}: MicrositeListFetchErrorProps) {
  const { tenantId } = useTenantData();
  const { data: contentSettings } = useTenantContentSettingsGet(
    { tenantId },
    { enabled: !!tenantId },
  );

  return (
    <EmptyState
      title={title ?? contentSettings.micrositeListFetchErrorTitle}
      message={
        <Flex direction="column" gap={4} align="center">
          <Text variant="secondary" fontSize="sm" textAlign="center">
            {message ?? contentSettings.micrositeListFetchErrorMessage}
          </Text>
          <Button
            variant="primary"
            size="sm"
            data-testid={testId}
            onClick={onRetry}
            isLoading={isRetrying}
            isDisabled={isRetrying}
          >
            {contentSettings.micrositeListFetchErrorRetryButton}
          </Button>
        </Flex>
      }
    />
  );
}
